import React, { useState } from 'react';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Box,
    Grid,
    TextField,
    FormControlLabel,
    Switch,
    Chip,
    Paper,
} from '@mui/material';
import {
    ExpandMore as ExpandMoreIcon,
    Settings as SettingsIcon,
} from '@mui/icons-material';
import StatusChip from '../../components/common/StatusChip';

const SettingsCategories = ({ categories, settings, onSettingChange }) => {
    const [expanded, setExpanded] = useState(
        categories.length > 0 ? { [categories[0].category.id || 'uncategorized']: true } : {}
    );

    const toggleExpanded = (id) => {
        setExpanded(prev => ({ ...prev, [id]: !prev[id] }));
    };

    const renderField = (setting) => {
        const value = settings[setting.key] || setting.value || '';

        switch (setting.value_type) {
            case 'boolean':
                return (
                    <FormControlLabel
                        control={
                            <Switch
                                checked={value === 'true' || value === true || value === '1'}
                                onChange={(e) => onSettingChange(setting.key, e.target.checked ? 'true' : 'false')}
                            />
                        }
                        label={value === 'true' || value === true || value === '1' ? 'Activado' : 'Desactivado'}
                    />
                );
            case 'json':
                return (
                    <TextField
                        multiline rows={4} fullWidth size="small"
                        value={value}
                        onChange={(e) => onSettingChange(setting.key, e.target.value)}
                        placeholder='{"key": "value"}'
                    />
                );
            default:
                return (
                    <TextField
                        fullWidth size="small"
                        type={['integer', 'decimal'].includes(setting.value_type) ? 'number' : 'text'}
                        value={value}
                        onChange={(e) => onSettingChange(setting.key, e.target.value)}
                    />
                );
        }
    };

    if (categories.length === 0) {
        return (
            <Paper sx={{ p: 4, textAlign: 'center', borderRadius: '0.75rem', border: '1px solid #d0dbe7' }}>
                <Typography sx={{ color: '#4e7397' }}>No hay configuraciones disponibles.</Typography>
            </Paper>
        );
    }

    return (
        <Box>
            {categories.map((catData) => {
                const catId = catData.category.id || 'uncategorized';
                const isExp = expanded[catId] || false;

                return (
                    <Accordion
                        key={catId}
                        expanded={isExp}
                        onChange={() => toggleExpanded(catId)}
                        sx={{
                            mb: 2,
                            borderRadius: '0.75rem',
                            border: '1px solid #d0dbe7',
                            boxShadow: 'none',
                            '&:before': { display: 'none' },
                        }}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon sx={{ color: '#800020' }} />}
                            sx={{
                                bgcolor: '#f6f7f8',
                                borderRadius: isExp ? '0.75rem 0.75rem 0 0' : '0.75rem',
                                '&:hover': { bgcolor: '#f0f0f0' },
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                                <SettingsIcon sx={{ color: '#800020' }} />
                                <Typography sx={{ fontWeight: 600, color: '#0e141b' }}>
                                    {catData.category.name || 'Sin Categoría'}
                                </Typography>
                                <Chip
                                    label={catData.settings.length}
                                    size="small"
                                    sx={{ bgcolor: '#800020', color: '#ffffff', fontSize: '0.75rem', ml: 'auto', mr: 2 }}
                                />
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails sx={{ p: 3 }}>
                            <Grid container spacing={3}>
                                {catData.settings.map((setting) => (
                                    <Grid item xs={12} md={6} key={setting.id}>
                                        <Box sx={{ mb: 2 }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                                <Typography sx={{ fontWeight: 500, color: '#0e141b', fontSize: '0.875rem' }}>
                                                    {setting.label}
                                                </Typography>
                                                <StatusChip status={setting.value_type} type="value-type" />
                                            </Box>
                                            {setting.description && (
                                                <Typography sx={{ color: '#4e7397', fontSize: '0.75rem', mb: 1 }}>
                                                    {setting.description}
                                                </Typography>
                                            )}
                                            {renderField(setting)}
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                );
            })}
        </Box>
    );
};

export default SettingsCategories;
